<template>
    <div>
        <div class="new-top">
            <div style="height:8px"></div>
            <div class="slider-banner banner">
                <swiper :options="swiperOption">
                    <swiper-slide
                        v-for="(item, index) in dataSource.banner_new"
                        :key="index"
                    >
                        <img :src="item.pic" />
                    </swiper-slide>
                    <div
                        class="swiper-pagination paginationBanner"
                        slot="pagination"
                    ></div>
                </swiper>
            </div>
            <div class="new-list row-flex row-around-center">
                <div class="new-li" @click="selectWeb(1)">
                    <img src="../assets/newImg/company.png" alt="" />
                    <!-- <div>公司优势</div> -->
                </div>
                <div class="new-li" @click="selectWeb(2)">
                    <img src="../assets/newImg/product.png" alt="" />
                    <!-- <div>产品优势</div> -->
                </div>
                <div class="new-li" @click="selectWeb(3)">
                    <img src="../assets/newImg/intrduce.png" alt="" />
                    <!-- <div>模式介绍</div> -->
                </div>
            </div>
        </div>
        <div class="news row-flex row-between-center">
            <img src="../assets/newImg/one.png" alt="" />
        </div>
        <div class="index-video" v-if="dataVideo.url">
            <img
                v-if="showVideo"
                src="../assets/newImg/start.png"
                class="start-img"
                alt=""
                @click="videoPlay"
            />
            <img v-if="showVideo" :src="poster" class="poster" alt="" />
            <video
                width="375"
                height="160"
                controls
                :src="dataVideo.url" 
            ></video>
        </div>
        <div class="news row-flex row-between-center">
            <img src="../assets/newImg/new_people.png" alt="" />
        </div>
        <index-goods :likeInfo="productList" shop_type="2" :is_buy_new="is_buy_new" ref="container"></index-goods>
        <div style="height:30px"></div>
    </div>
</template>
<style lang="scss" scoped>
.banner {
    width: 7rem;
    margin: 0 auto;
    border-radius: 10px;
    height: 150px !important;
}
.banner img {
    height: 150px;
}
.new-top {
    height: 270px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 2px 14px 0px rgba(228, 228, 228, 0.82);
    .new-list {
        // height: 90px;
        padding: 14px 0;
        .new-li {
            width: 33.33%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img {
                width: 110px;
                height: 80px;
            }
            div {
                font-size: 15px;
                padding: 10px 0;
            }
        }
    }
}
.news {
    height: 42px;
    padding: 0 10px;
    margin: 18px 0;
    img {
        width: 100%;
        height: 66px;
    }
}
.index-video {
    width: 100%;
    height: 160px;
    overflow: hidden;
    position: relative;
}
.index-video video {
    width: 100%;
    height: 100%;
}
.index-video .poster {
    width: 100%;
    height: 100%;
}
.index-video .start-img {
    width: 40px;
    height: 32px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import indexGoods from "@/components/indexGoods";
import { newVideo } from "@api/user";
import { getProducts } from "@api/store";
import {getUser} from '@api/user';

export default {
    name: "newborn",
    components: {
        swiper,
        swiperSlide,
        indexGoods,
    },
    data() {
        return {
            is_buy_new:0,
            showVideo: true,
            productList: [],
            dataSource: {},
            poster: "",
            url: "",
            dataVideo: {},
            swiperOption: {
                pagination: {
                    el: ".paginationBanner",
                    clickable: true,
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000,
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true,
                on: {
                    tap: function() {
                        const realIndex = this.realIndex;
                        vm.goUrl(realIndex);
                    },
                },
            },
            swiperRoll: {
                direction: "vertical",
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000,
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true,
            },
            swiperScroll: {
                freeMode: true,
                freeModeMomentum: false,
                slidesPerView: "auto",
                observer: true,
                observeParents: true,
            },
            swiperBoutique: {
                pagination: {
                    el: ".paginationBoutique",
                    clickable: true,
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000,
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true,
            },
            swiperProducts: {
                freeMode: true,
                freeModeMomentum: false,
                slidesPerView: "auto",
                observer: true,
                observeParents: true,
            },
            where: {
                page: 1,
                limit: 8,
               shop_type:2
            },
        };
    },
    methods: {
        /**播放视频 */
        videoPlay() {
            var video = document.querySelector("video");
            video.play();
            this.showVideo = false;
        },
        /**优势 */
        selectWeb(e) {
            this.$router.push("/newborn/goods?id=" + e);
        },
        /**视频 */
        new_video() {
            newVideo().then((res) => {
                this.dataSource = res.data;
                this.poster = res.data.data.image;
                this.url = res.data.data.url;
                this.dataVideo = res.data.data;
            });
        },
        /**商品列表 */
        get_product_list() {
            var that = this;
            if (that.loading) return; //阻止下次请求（false可以进行请求）；
            if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
            that.loading = true;
            let q = that.where;
            getProducts(q).then((res) => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data);
                that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
                that.where.page = that.where.page + 1;
            });
        },
        /**查看是否购买过新人商品 */
        user(){
            getUser().then(res=>{
                this.is_buy_new=res.data.is_buy_new;
            })
        },
    },
    mounted() {
        if (this.$route.query.token && this.$route.query.token.length > 0) {
            let token = this.$route.query.token
            let time = this.$route.query.expires_time
            const datas = {
                token: token,
                expires_time: time
            };
            this.$store.commit("LOGIN", datas);
        }
        this.user();
        this.new_video();
        this.get_product_list();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.get_product_list();
        });
    },
};
</script>
